/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-18 11:04:49
 * @LastEditTime: 2022-03-22 09:50:51
 * @LastEditors: Yandong Hu
 * @Description:
 */
import { atom } from "recoil";
import { DEFAULT_EXPORT_NAME } from "./config.service";

const HeaderTextState = atom({
  key: "headerState",
  default: DEFAULT_EXPORT_NAME,
});

const headerService = {
  HeaderTextState,
};

export default headerService;
